<template>
    <div class="histroy-wrapper">
        <loading :ifLoadingStart="isLoading"></loading>
        <el-table
            v-if="!isLoading"
            :data="histroyList"
            style="width: 100%"
            row-key="version_id"
            :expand-row-keys="expandRow"
            @row-click="toggleExpansion">
            <el-table-column type="expand" :expand-change="onExpandChange">
                <div class="desc-infor-wrapper" slot-scope="{row}">
                    <div class="desc-left" v-if="row.app_basic !== ''">
                        <h4 class="title">作品信息</h4>
                        <p class="specific-desc" v-if="row.app_basic.language.length">
                            <span class="desc-title">开发语言：</span>
                            <span class="desc-text">
                                {{row.app_basic.language.join()}}
                            </span>
                        </p>
                        <p class="specific-desc" v-if="row.app_basic.sys_type !== '脚本工具' && row.app_basic.browser.length">
                            <span class="desc-title">浏览器兼容：</span>
                            <span class="desc-text">{{row.app_basic.browser.join()}}</span>
                        </p>
                        <p class="specific-desc" v-if="row.app_basic.deploy.length">
                            <span class="desc-title">部署环境：</span>
                            <span class="desc-text">{{row.app_basic.deploy.join()}}</span>
                        </p>
                        <p class="specific-desc" v-if="row.app_basic.i18n.length">
                            <span class="desc-title">语言支持：</span>
                            <span class="desc-text">{{row.app_basic.i18n.join()}}</span>
                        </p>
                        <p class="specific-desc" v-if="row.app_basic.labels.length">
                            <span class="desc-title">关联标签：</span>
                            <span class="desc-text">{{row.app_basic.labels.join()}}</span>
                        </p>
                    </div>
                    <div :class="['desc-right', { 'add-border': row.app_basic !== '' }]">
                        <h4 class="title">更新内容</h4>
                        <pre class="text" v-html="filterXSS(row.update_content)"></pre>
                    </div>
                </div>
            </el-table-column>
            <el-table-column
                label="版本号"
                prop="update_version">
                <div class="title-item" slot-scope="props">
                    <span>{{props.row.update_version}}</span>
                    <span v-if="props.row.isNew" class="new">new</span>
                </div>
            </el-table-column>
            <el-table-column
                label="依赖蓝鲸版本"
                prop="bk_version">
                <template slot-scope="props">
                    <span>{{ props.row.bk_version || '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="发布时间"
                prop="update_time"
                sortable>
            </el-table-column>
            <el-table-column
                label="大小"
                prop="file_size">
                <template slot-scope="props">
                    <span>{{ props.row.file_size || '--' }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="MD5"
                prop="file_md5"
                :width="360">
                <div class="file-md5" slot-scope="{row}">
                    <span>{{row.file_md5}}</span>
                    <el-tooltip class="item" effect="dark" content="复制" placement="top">
                        <span class="copy-icon" @click.stop="handleCopy(row.file_md5)"></span>
                    </el-tooltip>
                </div>
            </el-table-column>
            <el-table-column
                label=""
                prop="id">
                <div slot-scope="props">
                    <p :class="['text', { 'disabled': props.row.version_id === '' || props.row.version_id === 0 }]" 
                        @click.stop="download(props.row, props.$index)">
                        <i class="icon-xiazai"></i>下载
                    </p>
                </div>
            </el-table-column>
        </el-table>
        <v-alert :options="options"></v-alert>
    </div>
</template>
<script>
import vAlert from '../alert.vue';
import loading from '../loading.vue'
import bus from '@/js/bus.js'
export default {
    components: {
        vAlert,
        loading
    },
    data () {
        return {
            isLoading: true,
            expandRow: [],
            histroyList: [],
            options: {
                // 消息弹窗
                msgText: '',
                msgIsSuccess: true
            }
        }
    },
    mounted () {
        this.initHistroyInfo()
    },
    methods: {
        toggleExpansion (row) {
            const index = this.expandRow.findIndex(item => item === row.version_id)
            if (index > -1) {
                this.expandRow.splice(index, 1)
            } else {
                this.expandRow.push(row.version_id)
            }
        },
        onExpandChange ({ row }) {
            this.toggleExpansion(row)
        },
        unfoldFn (histroyItem) {
            histroyItem.isUnfold = !histroyItem.isUnfold
        },
        initHistroyInfo () {
            this.isLoading = true
            this.histroyList = []
            const params = {
                aspect:'changelog',
                page: 1,
                page_size: 9999
            }
            const requestUrl = `core/product/detail/${this.$route.params.aid}/`
            axios.post(myUrl + requestUrl, qs.stringify(params)).then((res) => {
                res = res.data
                this.isLoading = false
                if (res.result) {
                    res.data.app_changelog.forEach((item, index) => {
                        if (index === 0) {
                            this.expandRow.push(item.version_id)
                            this.$set(item, 'isNew', true)
                        }
                        this.$set(item, 'isUnfold', false)
                        item.file_md5 = item.file_md5 === null ? '' : item.file_md5
                        this.histroyList.push(item)
                    })
                } else {
                    this.options = {
                        msgText: res.message,
                        msgIsSuccess: false
                    }
                }
            }).catch ((error) => {
                console.log(error)
                this.isLoading = false
            })
        },
        download (item, index) {
            // 禁止下载
            if (item.version_id === '' || item.version_id === 0) {
                return
            }
            // 校验信息是否完善
            if (!this.$store.state.informationComplete) {
                bus.$emit('openInformationPopup', 'downLoad');
                return;
            }
            if (index === 0) {
                this.$parent.download()
                return
            }
            const requestUrl = `core/product/download/${this.$route.params.aid}/${item.version_id}/`
            axios.post(myUrl + requestUrl).then((res) => {
                res = res.data;
                if (res.result) {
                    window.location.href = res.data
                } else {
                    this.options = {
                        msgText: res.message,
                        msgIsSuccess: false
                    }
                }
            })
        },
        // 复制MD5
        handleCopy (text) {
            const textarea = document.createElement('textarea')
            textarea.setAttribute('readonly', '')
            textarea.style.position = 'absolute'
            textarea.style.left = '-9999px'
        
            document.body.appendChild(textarea)
            textarea.value = text
        
            textarea.select()
            try {
                document.execCommand('copy')
            } catch (error) {
                console.warn(error)
            }
            textarea.blur()
            document.body.removeChild(textarea)
            this.$message({
                message: '复制成功~',
                type: 'success'
            })
        }
    }
}
</script>
<style lang="scss">
    .histroy-wrapper .el-table {
        .el-table__header {
            th {
                background-color: #f0f1f5;
                color: #63656e;
                font-size: 12px;
                padding: 4px 0;
                // 排序图标修改
                .caret-wrapper {
                    .ascending {
                        border-bottom-color: #c0c4cc;
                    }
                    .descending {
                        border-top-color: #c0c4cc;
                    }
                }
                &.ascending .sort-caret.ascending {
                    border-bottom-color: #63656e;
                }
                &.descending .sort-caret.descending {
                    border-top-color: #63656e;
                }
            }
        }
        .el-table__expanded-cell {
            padding: 0;
        }
        .file-md5 {
            display: flex;
            align-items: center;
        }
        .copy-icon {
            height: 15px;
            width: 14px;
            background-image: url('../../images/application_detail/copy2.png');
            background-size: 100% 100%;
            font-size: 14px;
            display: none;
            margin-left: 10px;
            cursor: pointer;
            &:hover {
                color: #3a84ff;
                background-image: url('../../images/application_detail/copy1.png');
                background-size: 100% 100%;
            }
        }
        .text {
            font-size: 12px;
            text-align: left;
            display: flex;
            align-items: center;
            cursor: pointer;
            &.disabled {
                cursor: not-allowed;
                color: #c4c6cc;
                .icon-xiazai {
                    &::before {
                        color: #c4c6cc;
                    }
                }
            }
            .icon-xiazai {
                margin: 2px 5px 0 0;
                &::before {
                    color: #3a84ff;
                }
            }
        }
        .title-item {
            display: flex;
            align-items: center;
            .new {
                height: 16px;
                width: 30px;
                text-align: center;
                line-height: 16px;
                margin-left: 3px;
                background: #e4faf0;
                color: #14a568;
                font-size: 12px;
                font-weight: 700;
            }
        }
        .el-table__row:hover {
            cursor: pointer;
            td {
                background: #f0f1f5 !important;
            }
            .copy-icon {
                display: inline-block !important;
            }
        }
        td {
            font-size: 12px;
        }
        // 将el-table的展开图标替换为背景图
        .el-table__expand-icon{
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        .el-table__expand-icon 
        .el-icon-arrow-right {
            &:before {
                content: none;
            }
            height: 12px;
            width: 12px;
            background-image: url('../../images/application_detail/play-shape.png');
            background-size: 100% 100%;
        }

        .el-table__expand-icon--expanded
        .el-icon-arrow-right{
            &:before {
                content: none;
            }
            height: 14px;
            width: 14px;
            background-image: url('../../images/application_detail/down-shape.png');
            background-size: 100% 100%;
        }
    }
    
</style>
<style lang="scss" scoped>
    .histroy-wrapper {
        background: #fff;
    }
    .loading {
      margin: 100px 0 50px;
    }
    .desc-infor-wrapper {
        padding: 12px 36px 30px 36px;
        font-size: 0;
        background:rgba(251,251,251,1);
        opacity:0.9;
        .desc-left, .desc-right {
            display: inline-block;
            vertical-align: top;
            font-size: 14px;
        }
        .title {
            margin-bottom: 10px;
            font-size:14px;
            font-weight:bold;
            color: #63656e;
            line-height:19px;
        }
        .desc-left {
            position: relative;
            width: 31%;
            .specific-desc {
                color: #63656e;
                font-size: 0;
                line-height: 24px;
                .desc-title, .desc-text {
                    display: inline-block;
                    vertical-align: top;
                    font-size: 12px;
                }
                .desc-title {
                    color: #888991;
                }
                .desc-text {
                    margin-left: 4px;
                    width: 157px;
                }
            }
        }
        .desc-right {
            width: 69%;
            &.add-border {
                position: relative;
                padding-left: 27px;
                &::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 1px;
                    height: 92%;
                    background: #eeeeee;
                }
            }
            .text {
                line-height:24px;
                color: #63656e;
                padding: 0;
                border: none;
                background-color: transparent;
                white-space: pre-wrap;
                font-size: 12px;
                font-family: '微软雅黑';
            }
        }
    }
</style>




// WEBPACK FOOTER //
// histroy.vue?3b594649